"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _UITextToolbarIcon = _interopRequireDefault(require("UIComponents/editor/UITextToolbarIcon"));

var _SimpleStyledClickable = _interopRequireDefault(require("UIComponents/editor/internal/SimpleStyledClickable"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIDropdownCaret = _interopRequireDefault(require("UIComponents/dropdown/UIDropdownCaret"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _iterables = require("../../utils/iterables");

var _StyleProtectedUIDropdown = _interopRequireDefault(require("../style-protected/StyleProtectedUIDropdown"));

var _withDisabledContext = _interopRequireDefault(require("../hoc/withDisabledContext"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCaret = (0, _styledComponents.default)(_UIDropdownCaret.default).withConfig({
  displayName: "ToolbarDropdownButton__StyledCaret",
  componentId: "sc-1r8pr74-0"
})(_templateObject(), _colors.EERIE);

var ToolbarDropdownButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ToolbarDropdownButton, _Component);

  function ToolbarDropdownButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ToolbarDropdownButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ToolbarDropdownButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isOpen: false
    };

    _this.handleOpenChange = function (_ref) {
      var isOpen = _ref.target.value;
      var onOpenChange = _this.props.onOpenChange;

      if (onOpenChange) {
        onOpenChange(isOpen);
      }

      _this.setState({
        isOpen: isOpen
      });
    };

    return _this;
  }

  (0, _createClass2.default)(ToolbarDropdownButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tooltip = _this$props.tooltip,
          active = _this$props.active,
          buttonIconName = _this$props.buttonIconName,
          disabled = _this$props.disabled;
      var dropdownProps = (0, _iterables.pick)(Object.keys(_UIDropdown.default.propTypes), this.props);
      var tooltipOpen = this.state.isOpen ? false : undefined;
      return _react.default.createElement(_UITooltip.default, {
        disabled: disabled,
        title: tooltip,
        open: tooltipOpen,
        placement: "bottom"
      }, _react.default.createElement(_StyleProtectedUIDropdown.default, (0, _extends2.default)({}, dropdownProps, {
        disabled: disabled,
        Button: _SimpleStyledClickable.default,
        animateOnMount: true,
        buttonText: _react.default.createElement(_UITextToolbarIcon.default, {
          name: buttonIconName
        }),
        caretRenderer: _react.default.createElement(StyledCaret, {
          className: "m-x-1"
        }),
        onOpenChange: this.handleOpenChange,
        active: active
      })));
    }
  }]);
  return ToolbarDropdownButton;
}(_react.Component);

ToolbarDropdownButton.defaultProps = {
  menuWidth: 150
};
ToolbarDropdownButton.propTypes = {
  tooltip: _react.PropTypes.string.isRequired,
  buttonIconName: _react.PropTypes.string.isRequired,
  active: _react.PropTypes.bool,
  menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  onOpenChange: _react.PropTypes.func,
  disabled: _react.PropTypes.bool
};

var _default = (0, _withDisabledContext.default)(ToolbarDropdownButton);

exports.default = _default;
module.exports = exports.default;